module.exports = __webpack_public_path__ + "static/datatable-multipleline-do-2c04eb9bbc28f1644d4151161f917e51.png";